import { useIdentity } from '$api-clients/hooks';

/**
 * The user's primary "agent team" id — mirrors graph-api's
 * IdentityUser.agentTeam resolver: the first ACTIVE membership with the AGENT
 * role, falling back to the user's first team membership.
 *
 * Also exposes the underlying `/auth/userinfo` payload so consumers that need
 * both don't have to issue their own (SWR-deduped, but duplicate) call.
 */
export function useAgentTeamId() {
  const {
    data: userinfo,
    isLoading: isUserinfoLoading,
    error: userinfoError,
  } = useIdentity('/auth/userinfo');
  const userId = userinfo?.id;

  const {
    data: teamMembersResponse,
    isLoading: isTeamMembersLoading,
    error: teamMembersError,
  } = useIdentity(
    '/users/{userId}/team-members',
    userId ? { params: { path: { userId } } } : null,
  );

  const memberships = teamMembersResponse?.data;
  const agentTeamId = (
    memberships?.find(
      (membership) =>
        membership.roles.includes('AGENT') && membership.status === 'ACTIVE',
    ) ?? memberships?.[0]
  )?.teamId;

  return {
    agentTeamId,
    userinfo,
    isLoading: isUserinfoLoading || isTeamMembersLoading,
    error: userinfoError ?? teamMembersError,
  };
}
